import { NO_RATING_VALUE } from 'src/components/pages/[town-translit]/lpu/[lpu-translit]/_components/LpuRating/constants'

/**
 * Ширина прогресс-бара метрики рейтинга в процентах.
 *
 * Крупная шкала (популярность): `(value + 10) * 5`.
 * Обычная: `(value + 2) * 25`.
 */
export default function getStatProgressPercent(
  value: number | null,
  isLargeScale = false,
): number {
  if (value === null || value === NO_RATING_VALUE) {
    return 0
  }

  const percent = isLargeScale
    ? (value + 10) * 5
    : (value + 2) * 25

  if (percent < 0) {
    return 0
  }

  if (percent > 100) {
    return 100
  }

  return percent
}
